import React, { useCallback, useEffect, useMemo } from "react";
import { isSameDay, isSameYear, isToday, format, nextMonday, addDays, isBefore, isAfter, } from "date-fns";
import Button from "../../Button/Button";
import IconButton from "../../Button/IconButton";
import { Container, Header, Main, DayButton } from "./styles";
import { isSameMonthAndYear } from "../utils";
const week = Array(7)
    .fill(nextMonday(new Date()))
    .map((d, i) => addDays(d, i));
export function Calendar({ state: calendar, events: _events = [], onClick, onDateSelect, onViewTimeChange, colorScheme, isPreviousMonthButtonDisabled = false, isNextMonthButtonDisabled = false, }) {
    const { selectedDate, setSelectedDate, view } = calendar;
    /**
     * Optimization to aid in handling large event arrays.
     * */
    const events = useMemo(() => _events.filter((e) => isSameYear(new Date(e.timestamp), view.pointInTime.date)), [_events, view.pointInTime.date]);
    const handleDayClick = useCallback((newDate) => {
        if (isSameMonthAndYear(newDate, selectedDate.date) ||
            (isBefore(newDate, selectedDate.date) &&
                !isPreviousMonthButtonDisabled) ||
            (isAfter(newDate, selectedDate.date) && !isNextMonthButtonDisabled)) {
            setSelectedDate(newDate);
        }
    }, [
        selectedDate,
        isPreviousMonthButtonDisabled,
        isNextMonthButtonDisabled,
        setSelectedDate,
    ]);
    useEffect(() => {
        onDateSelect === null || onDateSelect === void 0 ? void 0 : onDateSelect({
            date: selectedDate.date,
            eventsOnDate: events.filter((e) => isSameDay(selectedDate.date, new Date(e.timestamp))),
        });
    }, [events, onDateSelect, selectedDate.date, selectedDate.seconds]);
    useEffect(() => {
        onViewTimeChange === null || onViewTimeChange === void 0 ? void 0 : onViewTimeChange({
            date: view.pointInTime.date,
            visibleDates: view.interval,
        });
    }, [
        onViewTimeChange,
        view.interval,
        view.pointInTime.date,
        view.pointInTime.seconds,
    ]);
    return (React.createElement(Container, { onClick: (e) => onClick === null || onClick === void 0 ? void 0 : onClick(e) },
        React.createElement(Header.Element, null,
            React.createElement(Header.Section, { style: { gap: "12px" } },
                React.createElement(IconButton, { onClick: () => calendar.addMonths(-1), icon: "arrow-left", colorScheme: colorScheme, variant: "ghost", isDisabled: isPreviousMonthButtonDisabled }),
                React.createElement(Button, { onClick: () => view.setPointInTime(Date.now()), colorScheme: colorScheme, variant: "ghost" },
                    format(view.pointInTime.date, "MMM"),
                    " ",
                    calendar.year),
                React.createElement(IconButton, { onClick: () => calendar.addMonths(+1), icon: "arrow-right", colorScheme: colorScheme, variant: "ghost", isDisabled: isNextMonthButtonDisabled }))),
        React.createElement(Main.Container, null,
            React.createElement(Main.WeekHeader, null, week.map((day) => (React.createElement(DayButton, { isActive: true, colorScheme: colorScheme, key: Number(day), isDisabled: true }, format(day, "E"))))),
            React.createElement(Main.Grid, null, view.interval.map((x) => (React.createElement(DayButton, { key: x.toDateString(), isSelected: isSameDay(x, selectedDate.date), isActive: x.getMonth() === view.pointInTime.date.getMonth(), onClick: () => handleDayClick(x), isToday: isToday(x), colorScheme: colorScheme },
                x.getDate(),
                React.createElement("div", null, events
                    .map((e) => (Object.assign(Object.assign({}, e), { date: new Date(e.timestamp) })))
                    .filter((e) => isSameDay(x, e.date))
                    .map((e) => e.component)))))))));
}
//# sourceMappingURL=Calendar.js.map